<smallstack-button [buttonConfiguration]="data()" [clickFn]="deleteEntity()"></smallstack-button>
